import _, { isUndefined } from 'lodash';
import { fetchTieredPricing } from '../../services/Api/DrugInfo';
import { DEFAULT_ZIPCODE, NAVITUS } from '../../constants/defaults';

const { API } = require('./../../config/' + process.env.REACT_APP_ENV);
const getTieredPricingData = async (
  qty = '',
  zipCode = '',
  ndc = '',
  setLc,
  setData,
  setLoader,
  displayQuantity,
  isCustomQuantity,
  setIsPricingUpdated
) => {
  if (!qty) {
    return {};
  }
  const zipCodeData = JSON.parse(localStorage.getItem('zipCodeData'));
  const newZip =
    _.isEmpty(zipCodeData) && _.isEmpty(zipCode)
      ? DEFAULT_ZIPCODE
      : zipCodeData && zipCodeData.zipCode
      ? zipCodeData.zipCode
      : zipCodeData;
  const tieredPricingData = await fetchTieredPricing(
    qty,
    newZip,
    ndc,
    displayQuantity,
    isCustomQuantity
  );
  let resp = {
    tieredPricingData
  };
  window.linkGeniusRx = resp && !_.isEmpty(resp.mailOrderPricings);
  let isNavitusPharmacy = false;
  if (API.ALLOW_NAVITUS && resp && !_.isEmpty(resp.pharmacyPricings)) {
    resp.PharmacyPricings = resp.pharmacyPricings.map(pharmacyData => {
      pharmacyData.prices.map(price => {
        if (price.pBAName === NAVITUS) isNavitusPharmacy = true;
      });
    });
    window.linkNavitus = isNavitusPharmacy;
  }
  try {
    window.intellimize && window.intellimize.activate();
  } catch (e) {
    console.log('intellimize not loaded', e);
  }
  if (setLc) {
    let lowestEle = _.getLowestPrice(tieredPricingData);
    resp.lowestPrice = lowestEle.price;
    resp.lowestPricePharmacyName = lowestEle.name;
  }
  if (setData && setLoader) {
    await setData(tieredPricingData);
    await setLoader(false);
    await setIsPricingUpdated(true);
    // let event = new CustomEvent("drug-list-updated");
    // await document.dispatchEvent(event);
  }

  return resp;
};

const delayTieredPricing = _.debounce(getTieredPricingData, 500);

export const updateDosage = async (
  type,
  name,
  selectedIds,
  setSelectedIds,
  drugStructure,
  initialIds,
  zipCode,
  customQuantity,
  setQuantity,
  setTieredPricingData,
  setTieredPricingLoader,
  setIsDefaultPage,
  setCustomQuantity,
  isSpecialityDrugNew,
  setIsPricingUpdated
) => {
  let id, newFormId, newDosageId, newQuantityId, quantityIdValue;
  let isCustomQtyValid = false;
  const { brandId, formId, dosageId, quantityId } = selectedIds;
  let { form, dosage, displayQuantity } =
    drugStructure.brandTypes[brandId].formTypes[formId].dosage[dosageId]
      .quantities[quantityId];
  if (customQuantity && !_.isEmpty(customQuantity))
    displayQuantity = customQuantity;
  let newState = { ...selectedIds };
  await setTieredPricingLoader(true);
  setIsDefaultPage(false);
  switch (type) {
    case 'brand':
      {
        let findObj = {
          brand: name.brand
        };
        if (Object.prototype.hasOwnProperty.call(name, 'drugType')) {
          findObj.drugType = name.drugType;
        }
        id = _.findConsolidatedBrandIndex(drugStructure.brandTypes, findObj);
        newFormId = _.findConsolidatedFormIndex(
          drugStructure.brandTypes[id].formTypes,
          form
        );
        if (customQuantity && !_.isEmpty(customQuantity))
          isCustomQtyValid = _.checkIfCustomQtyVisible(
            drugStructure.brandTypes[id].formTypes[newFormId].name
          );
        newDosageId = _.findConsolidatedDosageIndex(
          drugStructure.brandTypes[id].formTypes[newFormId].dosage,
          dosage
        );
        newQuantityId = _.findConsolidatedQuantityIndex(
          drugStructure.brandTypes[id].formTypes[newFormId].dosage[newDosageId]
            .quantities,
          displayQuantity
        );
        newState = {
          ...selectedIds,
          ...{
            brandId: id,
            formId: newFormId,
            dosageId: newDosageId,
            quantityId: newQuantityId
          }
        };
        await setSelectedIds(newState);
        isCustomQtyValid
          ? await setCustomQuantity(displayQuantity)
          : await setCustomQuantity('');
      }
      break;
    case 'form':
      id = _.findConsolidatedFormIndex(
        drugStructure.brandTypes[brandId].formTypes,
        name
      );
      if (customQuantity && !_.isEmpty(customQuantity)) {
        isCustomQtyValid = _.checkIfCustomQtyVisible(
          drugStructure.brandTypes[brandId].formTypes[id].name
        );
      }
      newDosageId = _.findConsolidatedDosageIndex(
        drugStructure.brandTypes[brandId].formTypes[id].dosage,
        dosage
      );
      newQuantityId = _.findConsolidatedQuantityIndex(
        drugStructure.brandTypes[brandId].formTypes[id].dosage[newDosageId]
          .quantities,
        displayQuantity
      );
      newState = {
        ...selectedIds,
        ...{
          formId: id,
          dosageId: newDosageId,
          quantityId: newQuantityId
        }
      };
      await setSelectedIds(newState);
      isCustomQtyValid
        ? await setCustomQuantity(displayQuantity)
        : await setCustomQuantity('');
      break;
    case 'dosage':
      if (customQuantity && !_.isEmpty(customQuantity))
        isCustomQtyValid = _.checkIfCustomQtyVisible(form);
      id = _.findConsolidatedDosageIndex(
        drugStructure.brandTypes[brandId].formTypes[formId].dosage,
        name
      );
      newQuantityId = _.findConsolidatedQuantityIndex(
        drugStructure.brandTypes[brandId].formTypes[formId].dosage[id]
          .quantities,
        displayQuantity
      );
      quantityIdValue = isCustomQtyValid ? quantityId : newQuantityId;
      quantityIdValue = isUndefined(
        drugStructure.brandTypes[brandId].formTypes[formId].dosage[id]
          .quantities[quantityIdValue]
      )
        ? 0
        : quantityIdValue;
      newState = {
        ...selectedIds,
        ...{
          dosageId: id,
          quantityId: quantityIdValue
        }
      };
      await setSelectedIds(newState);
      isCustomQtyValid
        ? await setCustomQuantity(displayQuantity)
        : await setCustomQuantity('');
      break;
    case 'quantity':
      id = _.findConsolidatedQuantityIndex(
        drugStructure.brandTypes[brandId].formTypes[formId].dosage[dosageId]
          .quantities,
        name
      );
      newState = { ...selectedIds, ...{ quantityId: id } };
      await setSelectedIds(newState);
      customQuantity = '';
      await setCustomQuantity('');
      break;
    case 'customQuantity':
      id = _.findConsolidatedQuantityIndex(
        drugStructure.brandTypes[brandId].formTypes[formId].dosage[dosageId]
          .quantities,
        name
      );
      if (id != 0) {
        newState = {
          ...selectedIds,
          ...{ quantityId: isCustomQtyValid ? quantityId : id }
        };
        await setCustomQuantity(Number(name));
      } else {
        await setCustomQuantity(name);
      }
      await setSelectedIds(newState);
      break;
    case 'mobileUpdate':
      await setSelectedIds(newState);
      await setCustomQuantity('');
      break;
    default:
      await setSelectedIds(initialIds);
  }
  const quantityObj =
    drugStructure.brandTypes[newState.brandId].formTypes[newState.formId]
      .dosage[newState.dosageId].quantities[newState.quantityId];
  await setQuantity(quantityObj);
  let qty =
    customQuantity && !_.isEmpty(customQuantity)
      ? customQuantity
      : quantityObj.quantity;

  // Asynchronously prevent overlapping Tiered Pricing API calls
  //console.log("quantityObj.isSpecialityDrug = ", quantityObj.isSpecialityDrug);
  if (quantityObj.isSpecialityDrug) {
    // set state to no coupon
    await setTieredPricingLoader(false);
    await isSpecialityDrugNew(true);
  } else {
    await isSpecialityDrugNew(false);
    delayTieredPricing.cancel();
    delayTieredPricing(
      type == 'customQuantity' ? name : qty,
      zipCode,
      quantityObj.ndc,
      false,
      setTieredPricingData,
      setTieredPricingLoader,
      quantityObj.displayQuantity,
      type == 'customQuantity',
      setIsPricingUpdated
    );
  }
};

export const fetchDrugData = async (
  drugName,
  selectedIds,
  setDrugStruct,
  setDrugInfo,
  setSelectedIds,
  updateLoader,
  setTieredPricingLoader,
  setTieredPricingData,
  zipCode,
  setLowestPrice,
  setQuantity,
  setBlogData,
  setPriceHistory,
  setReplaceableVariables,
  setLowestPricePharmacyName,
  setIsDefaultPage,
  pushRoute
) => {
  try {
    const drugData =
      typeof window !== 'undefined' &&
      typeof __INITIAL_DATA__ !== 'undefined' &&
      window.__INITIAL_DATA__;

    await setDrugStruct(drugData.drugStructure);
    await setDrugInfo(drugData.drugInformation);

    if (!_.isEmpty(drugData.drugStructure.drugIds)) {
      const newState = {
        ...selectedIds,
        ...drugData.drugStructure.drugIds
      };
      await setSelectedIds(newState);
      const { brandId, formId, dosageId, quantityId } = newState;
      const quantityObj =
        drugData.drugStructure.brandTypes[brandId].formTypes[formId].dosage[
          dosageId
        ].quantities[quantityId];
      setIsDefaultPage(true);
      await setQuantity(quantityObj);
      await setTieredPricingData(drugData.tieredPricingData);
      await setLowestPrice(drugData.tieredPricingData.lowestPrice);
      await setLowestPricePharmacyName(
        drugData.tieredPricingData.lowestPricePharmacyName
      );
      await setBlogData(drugData.blogData);
      await setPriceHistory(drugData.priceHistory);
      if (
        !_.isEmpty(drugData.drugInformation) &&
        !_.isEmpty(drugData.drugInformation.replaceableVariables)
      )
        await setReplaceableVariables(
          drugData.drugInformation.replaceableVariables
        );
    }
  } catch (err) {
    console.log(
      'Error fetching drug data from BFF, redirecting to old prescription page.'
    );
    console.log('Error: ', err.message);

    // Fallback to original drug page.
    pushRoute(`/prescription/${drugName}`);
  }
};

export const handleZipCode = async (
  zipCode = '',
  quantity = '',
  ndc = '',
  setTieredPricingLoader,
  setZipCode,
  setTieredPricingData,
  setLowesePrice,
  isCustomeQuantity,
  displayQuantity,
  setIsPricingUpdated
) => {
  // commented for SCDTC-9727
  // window.intellimize && window.intellimize.activate();
  await setTieredPricingLoader(true);
  await setZipCode(zipCode);
  const { tieredPricingData, lowestPrice } = await getTieredPricingData(
    quantity,
    zipCode,
    ndc,
    null,
    null,
    null,
    displayQuantity,
    isCustomeQuantity
  );
  await setTieredPricingData(tieredPricingData);
  if (lowestPrice && !_.isEmpty(tieredPricingData)) {
    await setLowesePrice(lowestPrice);
  }
  await setTieredPricingLoader(false);
  await setIsPricingUpdated(true);
  // let event = new CustomEvent("drug-list-updated");
  // await document.dispatchEvent(event);
};
